import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function operacaoliberacaoremotaconsulta(
  state = INITIAL_STATE,
  action
) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@operacaoliberacaoremotaconsulta/FIND_OPERACAOLIBERACAOREMOTACONSULTA':
      case '@operacaoliberacaoremotaconsulta/UPDATE_OPERACAOLIBERACAOREMOTACONSULTA':
      case '@operacaoliberacaoremotaconsulta/DELETE_OPERACAOLIBERACAOREMOTACONSULTA':
      case '@operacaoliberacaoremotaconsulta/STORE_OPERACAOLIBERACAOREMOTACONSULTA':
      case '@operacaoliberacaoremotaconsulta/OPERACAOLIBERACAOREMOTACONSULTA_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@operacaoliberacaoremotaconsulta/SUCCESS_REMOVE':
      case '@operacaoliberacaoremotaconsulta/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@operacaoliberacaoremotaconsulta/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.operacaoliberacaoremotaconsulta;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@operacaoliberacaoremotaconsulta/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.operacaoliberacaoremotaconsulta;
        break;
      }

      case '@operacaoliberacaoremotaconsulta/RECORD_FILTERING': {
        draft.loading = true;
        //draft.params = { ...draft.params, ...action.payload.params };
        draft.params = action.payload.params;
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
